<template>
  <div class="loader-container">
    <button :type="type" @click="$emit('click')" :disabled="isLoading || disabled" :class="{'loading':isLoading}">
      <slot v-if="!isLoading || withText" name="content" />
      <div v-if="isLoading" class="loader-dots">
        <div class="loader-dot first" />
        <div class="loader-dot second" />
        <div class="loader-dot third" />
      </div>
    </button>
    <slot v-if="isLoading" name="loading-text" />
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    withText: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  .loader-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    > :nth-child(2) {
      margin-top: 0.5rem;
    }
  }

  button {
    display: flex;
    width: 100%;

    &.loading {
      &:disabled {
        background-color: $primary-500;
        border-color: transparent;
        opacity: 0.8;
        color: $white;
        font-weight: bold;
      }
    }

    > :nth-child(2) {
      top: 1px;
      margin-left: 0.5rem;
    }
  }

  .loader-dots {
    display: flex;
    align-items: center;
    height: 1.125rem;

    .loader-dot {
      width: 0.375rem;
      height: 0.375rem;
      border-radius: 0.375rem;
      margin: 0 0.125rem;
      background-color: $white;

      &.first {
        animation: dot1 1.2s infinite linear;
      }

      &.second {
        animation: dot2 1.2s infinite linear;
      }

      &.third {
        animation: dot3 1.2s infinite linear;
      }
    }
  }

  @keyframes dot1 {
    0% {
      opacity: 1;
    }

    33% {
      opacity: 0.33;
    }

    66% {
      opacity: 0.33;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes dot2 {
    0% {
      opacity: 0.33;
    }

    33% {
      opacity: 1;
    }

    66% {
      opacity: 0.33;
    }

    100% {
      opacity: 0.33;
    }
  }

  @keyframes dot3 {
    0% {
      opacity: 0.33;
    }

    33% {
      opacity: 0.33;
    }

    66% {
      opacity: 1;
    }

    100% {
      opacity: 0.33;
    }
  }
</style>
